import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Barlow\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"300\",\"400\",\"500\",\"600\",\"700\",\"900\"],\"display\":\"swap\"}],\"variableName\":\"barlow\"}");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs/src/app/assets/facebook-logo.png");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs/src/app/assets/ig-logo.png");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs/src/app/assets/linkedin-logo.png");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs/src/app/assets/tiktok-logo.png");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs/src/app/assets/x-logo.png");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs/src/app/assets/youtube-logo.png");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/corporate-nextjs/src/components/layout/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LenisProvider"] */ "/var/www/corporate-nextjs/src/components/provider/lenisProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/corporate-nextjs/src/components/ui/popup.tsx");
